<template>
    <v-app>
        <router-view />
    </v-app>
</template>

<script>
import '@coroot/coroot/src/app.css';

export default {
};
</script>

<style>
.v-application {
    //font-family: Poppins,sans-serif;
}

h1 {
    font-size: 30px;
    font-weight: 600;
    margin-top: 30px;
    margin-bottom: 30px;
}

h2 {
    font-size: 20px;
    font-weight: 500;
    margin-top: 40px;
    margin-bottom: 16px;
}
h3 {
    font-size: 16px;
    font-weight: 400;
    margin-top: 36px;
    margin-bottom: 16px;
}

@media (min-width: 600px) {
    h1 {
        font-size: 36px;
    }
    h2 {
        font-size: 22px;
    }
    h3 {
        font-size: 18px;
    }
}
@media (min-width: 960px) {
    h1 {
        font-size: 40px;
    }
    h2 {
        font-size: 24px;
    }
    h3 {
        font-size: 20px;
    }
}

p {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 16px;
}

i {
    //font-weight: 500;
}

ul {
    margin-bottom: 16px;
}
li {
    margin-bottom: 8px;
}
li::marker {
    //color: lightgray;
}

li ul {
    margin-top: 8px;
}

var {
    background-color: rgba(0,0,0,0.03);
    border-radius: 2px;
    padding: 0 4px 0 2px;
}

a {
    text-decoration: none;
}

.v-btn {
    text-transform: none;
    font-size: inherit !important;
    font-weight: inherit !important;
    letter-spacing: inherit !important;
}
.blue-btn {
    color: white !important;
    background-color: #0038fe !important;

}
.grey-border {
    border: 1px solid rgb(189, 189, 189);
}

a.outlined {
    color: white !important;
    padding: 4px 24px;
    border: white solid 2px !important;
    border-radius: 4px;
}
a.outlined:hover {
    color: white !important;
    border-color: #0038fe !important;
}
a.filled-green {
    color: black !important;
    background-color: #51e14c !important;
    padding: 4px 24px;
    border: #51e14c solid 2px !important;
    border-radius: 4px;
    font-weight: 500;
    font-size: 18px;
}
a.filled-green:hover {
    /*color: black !important;*/
    background-color: #73f16f !important;
    border-color: #73f16f !important;
}
a.filled-blue {
    color: white !important;
    background-color: #0038fe !important;
    padding: 4px 24px;
    border: #0038fe solid 2px !important;
    border-radius: 4px;
    font-weight: 500;
    font-size: 18px;
}
a.filled-blue:hover {
    color: white !important;
    background-color: #2958fd !important;
    border-color: #2958fd !important;
}

a:after {
    font-family: "Material Design Icons",serif;
    font-size: 18px;
    /*color: #080d1b;*/
    opacity: 0.4;
    margin: 0 2px;
}
/*https://pictogrammers.github.io/@mdi/font/5.9.55/*/
/*a[href^="http"]:after {*/
/*    content: "\F03CC";*/
/*}*/
/*a[href^="/docs/"]:after {*/
/*    content: "\F0474";*/
/*}*/
/*a[href^="/scenario/"]:after {*/
/*    content: "\F0238";*/
/*}*/

a.app-link:after {
    content: none;
}

.v-input.secure input {
    font-family: text-security-disc; /* workaround for firefox */
    -webkit-text-security: disc;
}

.green-btn {
    color: black !important;
    background-color: #51e14c !important;
    border-color: #51e14c !important;
    font-size: 20px !important;
    font-weight: 500 !important;
}
.green-btn:hover {
    background-color: #73f16f !important;
    border-color: #73f16f !important;
}

/* don't want smaller and bold items in dense lists, e.g. <v-select dense /> */
.v-list--dense .v-list-item .v-list-item__title {
    font-size: inherit;
    font-weight: inherit;
}

.theme--light.v-label {
    color: inherit;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active{
    -webkit-box-shadow: 0 0 0 30px white inset !important;
}

*::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
}
*::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
}
*::-webkit-scrollbar-thumb {
    background-color: #757575;
}

a#CybotCookiebotDialogPoweredbyCybot,
div#CybotCookiebotDialogPoweredByText {
    display: none;
}
#CookiebotWidget .CookiebotWidget-body .CookiebotWidget-main-logo {
    display: none;
}
</style>
